import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse/types'
import {
  getRatingsByLocation,
  RatingsByLocation,
} from 'api/pulse/ratingsByLocation'
import { getRatingsByLocationKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useRatingsByLocation(query: PulsePaginatedFilters) {
  return useInfiniteQuery<RatingsByLocation>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getRatingsByLocationKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getRatingsByLocation(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
